<div class="container">
  <div class="page">

    <div class="page-header">
      <h1 class="page-title">{{'Forbidden' | translate}}</h1>
    </div>

    <div class="page-body">

      <div class="content-wrapper">

        <p>{{'You do not have the permission to access this page' | translate}}</p>

      </div>

    </div>

  </div>

</div>

